export const initialState = [];
export function init(initialState) {
    return initialState
}